import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    setApplicantName,
    setApplicantSurName,
    setApplicantDateOfBirth,
    setApplicantCity,
    setApplicantStreet,
    setApplicantHouseNumber,
    setApplicantPostalCode,
    setApplicantPhone,
    setApplicantDetails,
    setShowError,
} from './applicantDetailsActions';
import ApplicantDetails from './ApplicantDetails';

function ApplicantDetailsContainer(props) {
    return (
        <ApplicantDetails
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            applicant={props.applicant}
            customer={props.customer}
            applicationId={props.applicationId}
            setApplicantNameField={props.setApplicantNameField}
            setApplicantSurNameField={props.setApplicantSurNameField}
            setApplicantDateOfBirthField={props.setApplicantDateOfBirthField}
            setApplicantCityField={props.setApplicantCityField}
            setApplicantStreetField={props.setApplicantStreetField}
            setApplicantPostalCodeField={props.setApplicantPostalCodeField}
            setApplicantHouseNumberField={props.setApplicantHouseNumberField}
            setApplicantPhoneField={props.setApplicantPhoneField}
            setApplicantDetails={props.setApplicantDetails}
            setShowError={props.setShowError}
            showError={props.showError}
        />
    );
}

const mapStateToProps = state => ({
    quickQuotes: state.quickQuoteReducer.quickQuotes,
    applicant: state.applicantDetailsReducer.applicant,
    showError: state.applicantDetailsReducer.showError,
    customer: state.customerReducer,
    applicationId: state.applicationIdReducer,
});

const mapDispatchToProps = dispatch => ({
    setApplicantNameField: (event) => {
        dispatch(setApplicantName(event));
    },
    setApplicantSurNameField: (event) => {
        dispatch(setApplicantSurName(event));
    },
    setApplicantDateOfBirthField: (event) => {
        dispatch(setApplicantDateOfBirth(event));
    },
    setApplicantCityField: (event) => {
        dispatch(setApplicantCity(event));
    },
    setApplicantPostalCodeField: (event) => {
        dispatch(setApplicantPostalCode(event));
    },
    setApplicantStreetField: (event) => {
        dispatch(setApplicantStreet(event));
    },
    setApplicantHouseNumberField: (event) => {
        dispatch(setApplicantHouseNumber(event));
    },
    setApplicantPhoneField: (event) => {
        dispatch(setApplicantPhone(event));
    },
    setApplicantDetails: (applicant) => {
        dispatch(setApplicantDetails(applicant));
    },
    setShowError: (fieldName) => {
        dispatch(setShowError(fieldName));
    },
});

ApplicantDetailsContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    applicant: PropTypes.object.isRequired,
    customer: PropTypes.object.isRequired,
    applicationId: PropTypes.string.isRequired,
    setApplicantNameField: PropTypes.func.isRequired,
    setApplicantSurNameField: PropTypes.func.isRequired,
    setApplicantDateOfBirthField: PropTypes.func.isRequired,
    setApplicantCityField: PropTypes.func.isRequired,
    setApplicantStreetField: PropTypes.func.isRequired,
    setApplicantPostalCodeField: PropTypes.func.isRequired,
    setApplicantHouseNumberField: PropTypes.func.isRequired,
    setApplicantPhoneField: PropTypes.func.isRequired,
    setApplicantDetails: PropTypes.func.isRequired,
    setShowError: PropTypes.func.isRequired,
    showError: PropTypes.object.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ApplicantDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetails/ApplicantDetailsContainer.js